import * as PassengersDetailsState from './passengers-details.state';
import * as PassengersDetailsActions from './passengers-details.actions';
import {INDRABookedTripDetails} from '@ibe.models/booked-trip-details.indra.model.lib';
import {RouterStateUrl} from '@ibe/store/states/router.state';
import {INDRAEmergencyData, INDRAPax, INDRATravelDoc} from '@ibe.models/pax.indra.model.lib';
import * as _ from 'lodash';
import {PassengerTravelDocument} from '@ibe.models/passenger.model';
import {ImmutableArrayUtils} from '@ibe/store/util';
import {SelectInputOption} from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';

export interface State extends PassengersDetailsState.State { }

const initialState: PassengersDetailsState.State = PassengersDetailsState.initialState;

/** mappers */
const mapFrequentFlyerOptions = (programs: any[]) =>
	programs['data'].map(program => ({ text: program.name, value: program.code } as SelectInputOption));

const mapEmergencyData = (emergencyData: INDRAEmergencyData): INDRAEmergencyData => emergencyData && emergencyData.declined ? {
	...emergencyData,
	emName: null,
	emCountry: null,
	emPrefix: null,
	emPhone: null
} : emergencyData;

const mapListTravelDoc = (docs: INDRATravelDoc[], newDocument: PassengerTravelDocument, mainInfo: any) => {
	// get gender and birthdate from main info form if both are NULL from travel doc object
	let newDocumentCopy: INDRATravelDoc;
	newDocumentCopy = newDocument ? _.cloneDeep(newDocument) : {};
	
	newDocumentCopy.birthDate = (!newDocumentCopy.birthDate && mainInfo) ? mainInfo.birthDate : newDocumentCopy.birthDate;
	newDocumentCopy.gender = (!newDocumentCopy.gender && mainInfo) ? mainInfo.gender : newDocumentCopy.gender;
	if (docs.length === 0) {
		return [newDocumentCopy];
	}
	return docs.map(it =>({ ...it, ...newDocumentCopy }));
}
	
	
const updatePassengers = (passengers: INDRAPax[], passenger: INDRAPax) => {
	return passengers.map(pax => pax.idPax === passenger.idPax ? passenger : pax);
};


export const getLoading = (state: PassengersDetailsState.State) => state.loading;
export const getBookedTrip = (state: PassengersDetailsState.State) => state.bookedTrip;
export const getInfoPax = (state: INDRABookedTripDetails) => state.data.infoPax;
export const getDocumentTypes = (state: PassengersDetailsState.State) => state && state.documentTypes;
export const getFrequentFlyerPrograms = (state: PassengersDetailsState.State) => state.frequentFlyerPrograms;
export const isFormChanges = (state: PassengersDetailsState.State) => state.formChanges;
export const getNotif = (state: PassengersDetailsState.State) => state.notif;
export const getFare = (state: INDRABookedTripDetails) => state && state.data && state.data.fare;

export const getPassengers = (state: INDRABookedTripDetails) => state.data.infoPax.listPax;
export const getPassengerAtIndex = (state: INDRAPax[], routerState: RouterStateUrl) =>
	!_.isEmpty(state) && !_.isNil(routerState.queryParams['id']) && state.find(s => Object.is(+routerState.queryParams['id'], s.idPax));

export const getEmergencyData = (state: INDRAPax) => state.emergencyData;

export const getLocations = (state: INDRABookedTripDetails) => state.translate.locations;

export function reducer(state = initialState, action: PassengersDetailsActions.Actions) {
	switch (action.type) {
		case PassengersDetailsActions.ActionTypes.LOADING:
			return {
				...state,
				loading: true,
				bookedTrip: null
			};
		case PassengersDetailsActions.ActionTypes.PUT_BOOKEDTRIP_PASSENGERS_DETAILS: {
			return {
				...state,
				loading: false,
				bookedTrip: action.payload
			};
		}
		case PassengersDetailsActions.ActionTypes.LOAD_DOCUMENT_TYPES_SUCCESS: {
			return {
				...state,
				documentTypes: action.payload
			};
		}
		case PassengersDetailsActions.ActionTypes.LOAD_FREQUENT_FLYER_PROGRAMS_SUCCESS: {
			const programs = mapFrequentFlyerOptions(action.payload);
			return {
				...state,
				frequentFlyerPrograms: programs
			};
		}
		case PassengersDetailsActions.ActionTypes.UPDATE_FORM_CHANGED: {
			return {
				...state,
				formChanges: {
					...state.formChanges,
					...action.payload
				}
			};
		}
		case PassengersDetailsActions.ActionTypes.HIDE_NOTIFICATION: {
			return {
				...state,
				notif: {
					...state.notif,
					show: false
				}
			};
		}
		case PassengersDetailsActions.ActionTypes.SAVE_PASSENGER_SUCCESS: {
			const { passenger_id } = action.payload.rq;
			const {
				emergencyContact,
				travelDocument,
				frequentFlyer,
				contact,
				mainInfo,
				studentInfo,
				residentInfo,
				travelInsurance,
				workInfo
			} = action.payload.rq.data;

			const passengers = getPassengers(state.bookedTrip);
			const passenger: INDRAPax = passengers.find(ps => Object.is(ps.idPax, passenger_id));
			const newPassenger: INDRAPax = {
				...passenger,
				...frequentFlyer,
				...contact,
				...mainInfo,
				...residentInfo,
				studentDocNumber: studentInfo.studentDocNumber,
				studentfiscalNumber: studentInfo.studentfiscalNumber,
				workTrip: workInfo && workInfo.workTrip === 'yes' ? true : false,
				travelInsurance: travelInsurance,
				emergencyData: mapEmergencyData(emergencyContact),
				listTravelDoc: mapListTravelDoc(passenger.listTravelDoc, travelDocument, mainInfo),
				tierLevelFF: action.payload.res['passenger-tier-level-info'] ? action.payload.res['passenger-tier-level-info'][passenger_id] : undefined
			};

			const listPax = updatePassengers(passengers, newPassenger);
			let bookedTrip = _.cloneDeep(state.bookedTrip);
			bookedTrip.data.infoPax.listPax = listPax;

			return {
				...state,
				// listPax: updatePassengers(passengers, newPassenger),
				bookedTrip: bookedTrip,
				formChanges: initialState.formChanges
			};
		}
		case PassengersDetailsActions.ActionTypes.SAVE_PASSENGER_ERRORS: {

			return {
				...state,
				notif: {
					icon: '',
					title: 'TAP',
					message: action.payload.map(error => error.desc),
					style: 'alert',
					show: true
				}
			};
		}
		case PassengersDetailsActions.ActionTypes.CANCEL_EDITING: {
			return {
				...state,
				formChanges: initialState.formChanges,
				notif: initialState.notif
			};
		}
		default:
			return state;
	}
}
